import { Strings } from '@/constants/strings';

interface AlgorithmInfoModalProps {
  visible: boolean;
  onClose: () => void;
}

export function AlgorithmInfoModal({ visible, onClose }: AlgorithmInfoModalProps) {
  if (!visible) return null;

  return (
    <div
      className="animate-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-lg"
      role="dialog"
      aria-modal="true"
      aria-labelledby="algorithm-modal-title"
      onClick={onClose}
    >
      <div
        className="animate-modal-content relative flex max-h-[90vh] w-full max-w-md flex-col rounded-3xl bg-white/90 shadow-xl backdrop-blur-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex shrink-0 items-center justify-between border-b border-border px-4 py-3">
          <h2 id="algorithm-modal-title" className="text-lg font-bold text-[#1A1A1A]">
            {Strings.algorithmModalTitle}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1.5 text-[#5C5C5C] hover:bg-surface focus:outline-none focus:ring-2 focus:ring-primary"
            aria-label="Kapat"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4">
          <section className="mb-5">
            <div className="mb-2 flex items-center gap-2">
              <span className="text-2xl" aria-hidden>
                🫀
              </span>
              <h3 className="text-base font-semibold text-[#1A1A1A]">
                {Strings.algorithmModalScore2Heading}
              </h3>
            </div>
            <p className="text-sm leading-relaxed text-[#1A1A1A]">
              {Strings.algorithmModalScore2Text}
            </p>
          </section>

          <section className="mb-5">
            <div className="mb-2 flex items-center gap-2">
              <span className="text-2xl" aria-hidden>
                👴
              </span>
              <h3 className="text-base font-semibold text-[#1A1A1A]">
                {Strings.algorithmModalScore2OpHeading}
              </h3>
            </div>
            <p className="text-sm leading-relaxed text-[#1A1A1A]">
              {Strings.algorithmModalScore2OpText}
            </p>
          </section>

          <section className="mb-5">
            <div className="mb-2 flex items-center gap-2">
              <span className="text-2xl" aria-hidden>
                ⚖️
              </span>
              <h3 className="text-base font-semibold text-[#1A1A1A]">
                {Strings.algorithmModalBmiHeading}
              </h3>
            </div>
            <p className="text-sm leading-relaxed text-[#1A1A1A]">
              {Strings.algorithmModalBmiText}
            </p>
          </section>

          <section className="mb-5">
            <div className="mb-2 flex items-center gap-2">
              <span className="text-2xl" aria-hidden>
                📋
              </span>
              <h3 className="text-base font-semibold text-[#1A1A1A]">
                {Strings.algorithmModalFindRiskHeading}
              </h3>
            </div>
            <p className="text-sm leading-relaxed text-[#1A1A1A]">
              {Strings.algorithmModalFindRiskText}
            </p>
          </section>

          <p className="rounded-lg bg-surface px-3 py-2.5 text-xs leading-relaxed text-[#5C5C5C]">
            {Strings.algorithmModalFooterNote}
          </p>
        </div>
      </div>
    </div>
  );
}
